import type {
  FilterConditionPluginSpecification,
} from '../filter.plugin';
import {
  FilterConditionPluginImpl
} from '../filter.plugin';
import type {
  BdCondition,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdYearsCondition,
} from '@bindoc-projects/condition-domain-lib';
import { BdArrayUtil } from '@bindoc-projects/util-domain-lib';

export const FilterConditionDismissalYearsPluginType: FilterConditionPluginSpecification<
  number[],
  FilterConditionDismissalYearsDto,
  BdYearsCondition
> = {
  type: 'dismissalYears',
  category: 'case',
  displayName: { de: 'Entlass Jahr' },
  sortingIndex: 8,
  occurrence: 'single',
  fromObject(
    obj: FilterConditionDismissalYearsDto,
  ): FilterConditionPluginImpl<number[]> {
    return new FilterConditionDismissalYearsPlugin(obj.years);
  },
  fromCondition(
    jsonObj: BdYearsCondition,
  ): FilterConditionPluginImpl<number[]> {
    return new FilterConditionDismissalYearsPlugin(jsonObj.includes ?? []);
  },
  newInstance(): FilterConditionPluginImpl<number[]> {
    return new FilterConditionDismissalYearsPlugin([]);
  },
};

export class FilterConditionDismissalYearsPlugin extends FilterConditionPluginImpl<
  number[],
  FilterConditionDismissalYearsDto
> {
  public static override Specification: FilterConditionPluginSpecification<
    number[],
    FilterConditionDismissalYearsDto,
    BdYearsCondition
  > = FilterConditionDismissalYearsPluginType;

  constructor(private years: number[]) {
    super(FilterConditionDismissalYearsPluginType.type);
  }

  clone(): FilterConditionDismissalYearsPlugin {
    return new FilterConditionDismissalYearsPlugin([...this.years]);
  }

  override equals(other: FilterConditionDismissalYearsPlugin): boolean {
    return super.equals(other) && BdArrayUtil.equals(this.years, other.years);
  }

  override validationToText(): string {
    if (this.years.length === 0) {
      return 'Mindestens ein Entlass-Jahr auswählen';
    } else {
      return '';
    }
  }

  toCondition(): BdCondition | null {
    return new BdYearsCondition(this.years, []);
  }

  toJSON(): FilterConditionDismissalYearsDto | null {
    return {
      type: this.type,
      years: this.years,
    };
  }

  toText(): string | null {
    return 'Entlass-Jahr';
  }

  toValue(): number[] {
    return this.years;
  }
}

interface FilterConditionDismissalYearsDto {
  type: string;
  years: number[];
}
